import { render, staticRenderFns } from "./RiskBySeverityCard.vue?vue&type=template&id=66a4646c&scoped=true&"
import script from "./RiskBySeverityCard.vue?vue&type=script&lang=ts&"
export * from "./RiskBySeverityCard.vue?vue&type=script&lang=ts&"
import style0 from "./RiskBySeverityCard.vue?vue&type=style&index=0&id=66a4646c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4646c",
  null
  
)

export default component.exports